import { mapGetters } from 'vuex'

export default {
  props: {
    variant: {
      type: String,
      default: 'default'
    },
  },
  computed: {
    ...mapGetters('booking', ['getBookingTrackingV2']),
    ...mapGetters('modifyReservation', ['getBookingTrackingModifyReservation']),
    ...mapGetters('spaSoft', ['getBookingTrackingSpaSoft']),
  },
  methods: {
    getTrackingData(type, query, eventData) {
      switch (type) {
        case 'booking':
          return this.getBookingTrackingV2(query, eventData)
        case 'modifyReservation':
          return this.getBookingTrackingModifyReservation(query, eventData)
        case 'spaSoft':
          return this.getBookingTrackingSpaSoft(eventData)
        default:
          throw Error('Current type is not defined')
      }
    }
  }
}
